import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import { TransitionProps } from '@material-ui/core/transitions';
import { Observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../../../../sharedComponents/Button';
import { user } from '../../models/User';

const Transition = React.forwardRef(
  (props: TransitionProps & { children?: React.ReactElement<any, any> }, ref: React.Ref<unknown>) => (
    <Slide direction='up' ref={ref} {...props} />
  )
);

const LogOutDialog = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Observer
        render={() => (
          <Dialog
            open={user.displaySignOutDialog}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => user.showSignOutDialog(false)}
            aria-labelledby='alert-dialog-slide-title'
            aria-describedby='alert-dialog-slide-description'
          >
            <DialogTitle id='alert-dialog-slide-title'>{t('Log out of dealer portal')}</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {t('Goodbye')} {user.name || user.userEmail} {t('close Dealer portal')}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => user.showSignOutDialog(false)} variant='outlined'>
                {t('Cancel')}
              </Button>
              <Button onClick={() => user.signOut()} color='primary'>
                {t('Log out')}
              </Button>
            </DialogActions>
          </Dialog>
        )}
      />
    </div>
  );
};

export default LogOutDialog;
